import React, { useState, useEffect, useRef } from 'react';
import { TextField, Button, Container, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Grid } from '@mui/material';
import axios from 'axios';
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import { useReactToPrint } from 'react-to-print';
import { CLIENT_ADDRESS_LINES, CLIENT_NAME, CLIENT_TELEPHONE } from '../config/clientInfo';

function Reservations() {
  const [formData, setFormData] = useState({
    customerName: '',
    customerNIC: '',
    mobileNo: '',
    reservationDate: '',
    advanceAmount: '',
  });

   const ReturnprintsRef = useRef();
  const [reservations, setReservations] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [deleteLoading,setDeleteLoading] = useState(false)
    const [selectedBillItems, setSelectedBillItems] = useState([]);
    const [selectedBillMeta, setSelectedBillMeta] = useState(null);
    
  const formatTwoDigits = (val) => (val < 10 ? `0${val}` : val);

  const toEdit = (row) => {
    const confirmDelete = window.confirm(`Are you sure you want to delete reservation ?`);
  
    if (!confirmDelete) {
      return; // Exit if the user cancels
    }
  
    setDeleteLoading(true);
  
    const data = {
      id: row.ItemID,
    };
  
    axios.post(`https://serverrion.mylksystems.store/reservations/deleteReservation`, data)
      .then((res) => {
        toast.success('Deleted Successfully');
        fetchReservations();
        setDeleteLoading(false);
      })
      .catch((e) => {
        toast.error('Error Deleting');
        setDeleteLoading(false);
      });
  };
  
  // Fetch reservations from API
  useEffect(() => {
    fetchReservations();
  }, []);

  const fetchReservations = async () => {
    try {
      const response = await axios.get('https://serverrion.mylksystems.store/reservations/getAllReservations');
      setReservations(response.data);
    } catch (error) {
      console.error('Error fetching reservations:', error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post('https://serverrion.mylksystems.store/reservations/createReservation', formData);
      toast.success('Reservation added successfully');
      setFormData({
        customerName: '',
        customerNIC: '',
        mobileNo: '',
        reservationDate: '',
        advanceAmount: '',
      });
      fetchReservations(); // Refresh the table after adding a new reservation
    } catch (error) {
      console.error('Error adding reservation:', error);
      toast.error('Failed to add reservation');
    } finally {
      setLoading(false);
    }
  };

  // Filter reservations based on search term
  const filteredReservations = reservations.filter((reservation) =>
    reservation.nic.toLowerCase().includes(searchTerm.toLowerCase()) ||
    reservation.ItemName.toLowerCase().includes(searchTerm.toLowerCase())
  );

    const handlePrint = async (reservation) => {
      try {

        
        if (reservation) {
          const meta = {
            inv_no: 'Reservataion_'+reservation.ItemID,
            username: JSON.parse(localStorage.getItem("AutoParts"))?.username,
            inv_date:reservation.reservationDate,
            gross_total: reservation.sellingPrice,
            discount: 0.00,
            net_total: reservation.sellingPrice,
            Service_chrg: 'Pending',
            ItemName: reservation.ItemName,
            qty: 1,

          };


          setSelectedBillItems(meta);
          setSelectedBillMeta(meta);
          setTimeout(() => handlePrintTrigger(), 200);
        }
      } catch (err) {
        console.error('Error fetching single bill:', err);
      }
    };
  
    const handlePrintTrigger = useReactToPrint({
      content: () => ReturnprintsRef.current,
    });
  


    const renderPrintableBill = () => {
      if (!selectedBillMeta || selectedBillItems.length === 0) return null;
  
      const today = new Date();
      const year = today.getFullYear();
      const month = formatTwoDigits(today.getMonth() + 1);
      const day = formatTwoDigits(today.getDate());
  
      return (
        <div style={{ display: 'none' }}>
          <table
            border={0}
            width="300"
            style={{ fontFamily: 'Consolas', backgroundColor: 'white', fontWeight: 'bold' }}
            ref={ReturnprintsRef}
          >
            <tbody>
              <tr>
                <td colSpan={4} align="center">
                  <img src={require('../Assests/billLogo.png')} alt="" width={150} />
                </td>
              </tr>
              <tr>
                <td colSpan={4} align="center">
                  <b>{CLIENT_NAME}</b><br />
                  {CLIENT_ADDRESS_LINES[0]}<br />
                  {CLIENT_ADDRESS_LINES[1]}<br />
                  Tel. {CLIENT_TELEPHONE}
                </td>
              </tr>
              <tr><td colSpan={4}>---------------------------------</td></tr>
              <tr><td colSpan={4}>Cashier: {selectedBillMeta.username}</td></tr>
              <tr><td colSpan={4}>Reservation Date: {selectedBillMeta.inv_date}</td></tr>
              <tr><td colSpan={4}>Invoice no: {selectedBillMeta.inv_no}</td></tr>
              <tr><td colSpan={4}>---------------------------------</td></tr>
  
           
                  <tr>
                    <td colSpan={4}>{1}). Name : {selectedBillMeta.ItemName}</td>
                  </tr>
                  <tr>
                    <td align="right">{selectedBillMeta.qty}</td>
                    <td align="center">{parseFloat(selectedBillMeta.gross_total).toFixed(2)}</td>
                    <td align="right">{parseFloat(selectedBillMeta.gross_total).toFixed(2)}</td>
                  </tr>
            
              <tr><td colSpan={4}>---------------------------------</td></tr>
              <tr>
                <td colSpan={2} align="left">Gross Rs.</td>
                <td colSpan={2} align="right"> {selectedBillMeta.gross_total}</td>
              </tr>
              {/* <tr>
                <td colSpan={2} align="left">Discount Rs.</td>
                <td colSpan={2} align="right"> ({selectedBillMeta.discount})</td>
              </tr> */}
              {/* <tr>
                <td colSpan={2} align="Left">Service Charge Rs.</td>
                <td colSpan={2} align="right"> {selectedBillMeta.Service_chrg}</td>
              </tr> */}
                <tr><td colSpan={4}>---------------------------------</td></tr>
              
  
              <tr><td colSpan={4} align="right"><b>Total Rs. {selectedBillMeta.net_total}</b></td></tr>
                 <tr>
                <td colSpan={4} align='right'>==========</td>
              </tr>
              <tr><td colSpan={4} align="center" style={{fontSize : 12}}>Thank you, Come Again.</td></tr>
              <tr><td colSpan={4}>---------------------------------</td></tr>
            </tbody>
          </table>
        </div>
      );
    };

  return (
   <Container maxWidth={false} disableGutters sx={{ paddingTop: '10vh', paddingX: 2 }}>
      <Grid container spacing={2}>
        {/* Reservation Form */}
        <Grid item xs={12} md={4}>
          <Typography variant="h4" gutterBottom>
            Add Reservation
          </Typography>
          <form>
            <TextField
              fullWidth
              margin="normal"
              label="Customer Name"
              name="customerName"
              value={formData.customerName}
              onChange={handleChange}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label="Customer NIC"
              name="customerNIC"
              value={formData.customerNIC}
              onChange={handleChange}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label="Mobile No"
              name="mobileNo"
              value={formData.mobileNo}
              onChange={handleChange}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label="Reservation Date"
              name="reservationDate"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={formData.reservationDate}
              onChange={handleChange}
              required
            />
            <TextField
              fullWidth
              margin="normal"
              label="Advance Amount"
              name="advanceAmount"
              type="number"
              value={formData.advanceAmount}
              onChange={handleChange}
              required
            />
            <Button onClick={handleSubmit} variant="contained" color="primary" fullWidth>
              {loading ? <BeatLoader color="#fff" loading={loading} size={10} /> : 'Submit'}
            </Button>
          </form>
        </Grid>

        {/* Reservation Table */}
        <Grid item xs={12} md={8}>
          <Typography variant="h4" gutterBottom>
            Reservations
          </Typography>
          <TextField
            fullWidth
            margin="normal"
            label="Search by NIC or Item Name"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <TableContainer component={Paper} sx={{ maxHeight: 400, overflowY: 'auto' }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell style={{fontWeight : 'bold'}}>Customer Name</TableCell>
                  <TableCell style={{fontWeight : 'bold'}}> Amount</TableCell>
                  <TableCell style={{fontWeight : 'bold'}}>Date</TableCell>
                  <TableCell style={{fontWeight : 'bold'}}>NIC</TableCell>
                  <TableCell style={{fontWeight : 'bold'}}>Mobile No</TableCell>
                  {JSON.parse(localStorage.getItem("AutoParts"))?.role === 1 ?
                  <TableCell style={{fontWeight : 'bold'}}>Printed</TableCell>
                  :<></>}
                  <TableCell style={{fontWeight : 'bold'}}>Actions</TableCell>
                  <TableCell style={{fontWeight : 'bold'}}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredReservations.map((reservation,i) => (
                  <TableRow key={reservation.id}>
                    <TableCell>{reservation.ItemName}</TableCell>
                    <TableCell>{reservation.sellingPrice}</TableCell>
                    <TableCell>{reservation.reservationDate}</TableCell>
                    <TableCell>{reservation.nic}</TableCell>
                    <TableCell>{reservation.mobileNo}</TableCell>
                    <TableCell>{reservation.IsActive === 1 ? 'Not Printed': 'Printed'}</TableCell>
                    {JSON.parse(localStorage.getItem("AutoParts"))?.role === 1 ?
                    <TableCell>

                      <Button variant = 'contained' onClick={() => {toEdit(reservation)}}>
                                                                {deleteLoading?<>
                                                                    <BeatLoader color='#000000' size={10} />
                                                                </>:<>Delete</>}</Button>
                    
                    </TableCell> 
                    
                    : <></>}

                    <TableCell><Button variant = 'contained'onClick={() => handlePrint(reservation)}>
                                                                Print</Button></TableCell>
                   
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
        {renderPrintableBill()}
    </Container>
  );
}

export default Reservations;
